module.exports = __webpack_public_path__ + "apprl-touch-icon-60x60.7cbf6a99238f4622c5a1768f989a529f.png";